module.exports = __webpack_public_path__ + "img/1_030.26499ce9.jpg";